import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const FinancialMindfulness = ({moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model}) => {
    const [{ data, loading }] = useAxios({ url: `internal/cobrand/audio/${cobrandId ? cobrandId : ''}`, method: "get" });
    return (
        <FeaturedList 
        moveItem={(index, direction) => moveItem("mindfulness", index, direction)}
        addItem={(option) => addItem("mindfulness", option)}
        removeItem={(id) => removeItem("mindfulness", id)}
        saveIndividual={saveIndividual}
        showUpdateBtn={showUpdateBtn}
        typeId={8}
        type="Financial Mindfulness:" 
        model={model} 
        availableItems={data} />
    );
};

export default FinancialMindfulness;